module.exports = __webpack_public_path__ + "img/call.dd982140.svg";